import request from "@/utils/request";

export const indexHot = (params) => {
  return request({
    url: "/Article/hot",
    method: "get",
    params,
  });
};

export const fetchArtcleCateList = (params) => {
  return request({
    url: "/ArticleCategory/index",
    method: "get",
    params,
  });
};

export const fetchArtcleList = (params) => {
  return request({
    url: "/Article/index",
    method: "get",
    params,
  });
};

export const detail = (params) => {
  return request({
    url: "/Article/detail",
    method: "get",
    params,
  });
};
